import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize, InputFieldType} from '@Components/input-field-v2/input-field.types';
import {MIN_INTRO_DELAY} from '@PosterWhiteboard/items/slideshow-item/slideshow-slides.class';
import styles from './slideshow-intro-delay-option.module.scss';

const MAX_INTRO_DELAY_DURATION = 600; // practical UI cap for intro delay slider

interface SlideshowIntroDelayOptionProps {
  introDelay: number;
  onChangeIntroDelay(val: number): void;
  onChangeIntroDelayEnded(val: number): void;
}

export function SlideshowIntroDelayOption({...props}: SlideshowIntroDelayOptionProps): ReactElement<any> | null {
  return (
    <div className={`${styles.container} flex-h-row`}>
      <div className={`${styles.introDelayContainer} flex-row-align-center radius-4`}>
        <Text size={TextSize.XSMALL} className="content-sub-text" val={window.i18next.t('pmwjs_intro_delay')} />
      </div>
      <div className={styles.introDelayInputField}>
        <InputField
          placeholder=" "
          onInputChange={(val: number): void => {
            props.onChangeIntroDelay(val);
          }}
          onInputChangeEnded={(val: number): void => {
            props.onChangeIntroDelayEnded(val);
          }}
          input={props.introDelay ?? 0}
          size={InputFieldSize.SMALL}
          hasIcon="icon-clock-o"
          elementTitle={window.i18next.t('pmwjs_intro_delay')}
          inputType={InputFieldType.NUMBER}
          inputClassName={styles.introDelayClassName}
          iconClassName="spacing-p-l-1"
          allowOnChangeWithKeys
          min={MIN_INTRO_DELAY}
          max={MAX_INTRO_DELAY_DURATION}
        />
      </div>
    </div>
  );
}
